"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64decode = exports.base64encode = void 0;
var base64_js_1 = require("base64-js");
function base64encode(text) {
    var i;
    var len = text.length;
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var u8array = new Arr(len);
    for (i = 0; i < len; i++) {
        u8array[i] = text.charCodeAt(i);
    }
    return base64_js_1.fromByteArray(u8array);
}
exports.base64encode = base64encode;
function base64decode(text) {
    var u8Array = base64_js_1.toByteArray(text);
    var i;
    var len = u8Array.length;
    var bStr = "";
    for (i = 0; i < len; i++) {
        bStr += String.fromCharCode(u8Array[i]);
    }
    return bStr;
}
exports.base64decode = base64decode;
window.btoa = window.btoa || base64encode;
window.atob = window.atob || base64decode;
//# sourceMappingURL=base64.js.map